import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const DATA_URL =
  "https://script.google.com/macros/s/AKfycby1QPnEMnnW2FTrz104vxGU4aKtLHy27ptPyo7yw9T1cnAm45_1AHxzaGolSNyh_qhiSw/exec";

const GRID_SIZE = 10;

const SuperBowlTV2026 = () => {
  const [cells, setCells] = useState([]);
  const [winners, setWinners] = useState({
    firstQuarter: { winner1: "", winner2: "" },
    secondQuarter: { winner1: "", winner2: "" },
    thirdQuarter: { winner1: "", winner2: "" },
    fourthQuarter: { winner1: "", winner2: "" },
  });
  const backgroundImage = useResponsiveImageUrl(
    "tv/superbowl-squares-bg-v3.jpg",
  );

  useEffect(() => {
    const fetchGrid = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`${DATA_URL}?t=${timestamp}`);
        const data = await response.json();

        if (Array.isArray(data)) {
          setCells(data);
        } else if (data && typeof data === "object") {
          if (Array.isArray(data.scavengerGrid)) {
            setCells(data.scavengerGrid);
          }

          if (data.winners && typeof data.winners === "object") {
            setWinners({
              firstQuarter: {
                winner1: data.winners["1st_quarter"]?.winner1 ?? "",
                winner2: data.winners["1st_quarter"]?.winner2 ?? "",
              },
              secondQuarter: {
                winner1: data.winners["2nd_quarter"]?.winner1 ?? "",
                winner2: data.winners["2nd_quarter"]?.winner2 ?? "",
              },
              thirdQuarter: {
                winner1: data.winners["3rd_quarter"]?.winner1 ?? "",
                winner2: data.winners["3rd_quarter"]?.winner2 ?? "",
              },
              fourthQuarter: {
                winner1: data.winners["4th_quarter"]?.winner1 ?? "",
                winner2: data.winners["4th_quarter"]?.winner2 ?? "",
              },
            });
          }
        }
      } catch (err) {
        console.error("Error fetching grid data:", err);
      }
    };

    fetchGrid();
    const interval = setInterval(fetchGrid, 5000);
    return () => clearInterval(interval);
  }, []);

  const cellMap = useMemo(() => {
    const map = new Map();
    cells.forEach((cell) => {
      map.set(`${cell.x},${cell.y}`, cell);
    });
    return map;
  }, [cells]);

  return (
    <TVContainer>
      <BackgroundImage
        src={backgroundImage}
        alt="Super Bowl Squares Background"
      />
      <WinnersPanel>
        <div>{winners.firstQuarter.winner1}</div>
        <div>{winners.firstQuarter.winner2}</div>
        <div>{winners.secondQuarter.winner1}</div>
        <div>{winners.secondQuarter.winner2}</div>
        <div>{winners.thirdQuarter.winner1}</div>
        <div>{winners.thirdQuarter.winner2}</div>
        <div>{winners.fourthQuarter.winner1}</div>
        <div>{winners.fourthQuarter.winner2}</div>
      </WinnersPanel>
      <BoardFrame>
        <GridWrapper>
          <Grid>
            {Array.from({ length: GRID_SIZE }).map((_, row) =>
              Array.from({ length: GRID_SIZE }).map((_, col) => {
                const cell = cellMap.get(`${col},${row}`) || {};
                return (
                  <GridCell key={`cell-${col}-${row}`}>
                    <CellTop>{cell.topValue ?? ""}</CellTop>
                    <CellBottom>{cell.bottomValue ?? ""}</CellBottom>
                  </GridCell>
                );
              }),
            )}
          </Grid>
        </GridWrapper>
      </BoardFrame>
    </TVContainer>
  );
};

const TVContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-color: #000;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: 0;
`;

const BoardFrame = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 24px 28px 28px;
  display: flex;
  flex-direction: column;
`;

const WinnersPanel = styled.div`
  position: absolute;
  top: 87px;
  right: 62px;
  font-size: 15px;
  line-height: 1;
  z-index: 2;
  color: #ffffff;
  width: min(26vw, 270px);
  height: min(10vh, 105px);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, 1fr);
  column-gap: 6px;
  align-items: center;
  text-align: center;
`;

const GridWrapper = styled.div`
  position: absolute;
  right: 40px;
  bottom: 20px;
  width: 78vw;
  height: 70vh;
`;

const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(10, 1fr);
  gap: 4.8px;
`;

const GridCell = styled.div`
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4.8px;
  font-size: clamp(1rem, 1.4vw, 1.7rem);
  box-shadow: none;
`;

const CellTop = styled.div`
  line-height: 1;
  padding: 0.1em 0;
  background-color: transparent;
  color: #ffffff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const CellBottom = styled.div`
  line-height: 1;
  padding: 0.1em 0;
  background-color: transparent;
  color: #000000;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export default SuperBowlTV2026;
